document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-toggle-menu]').forEach(el => {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            this.querySelector('.header__burger-switcher').classList.toggle('is-open');


            if(this.querySelector('.header__burger-switcher').classList.contains('is-open')){
                document.querySelector('body').classList.add('popup-lock');
                document.querySelector('.menu-catalog__wrapper').classList.add('open');
                document.querySelector('.menu-catalog').classList.add('open');
            } else {
                document.querySelector('body').classList.remove('popup-lock');
                document.querySelector('.menu-catalog__wrapper').classList.remove('open');
                document.querySelector('.menu-catalog').classList.remove('open');
            }

        });
    });
     setMenuPositionTop();
    headerFixed();

    $(window).scroll(function (event) {
        headerFixed();
    });
     // Фиксация шапки
    function headerFixed() {
        let st = $(window).scrollTop();
        // if (st > (($('.shop-link').outerHeight() ? $('.shop-link').outerHeight() : 0) + $('.header-top').outerHeight())) {
        if (st > 90) {
            $('header').addClass('fixed');
            $('.header').addClass('fixed');
            // $('.main-wrapper').addClass('fixed');
            setMenuPositionTop();
        } else if (st < 50) {
            $('header').removeClass('fixed');
            $('.header').removeClass('fixed');
            setMenuPositionTop();
        }
    }
})